/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError, ManageCodeLabelColumn } from '../../../../components';
import { roughness } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getRoughnessOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageRoughnesssTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getRoughnessOutput;
  columns: ManageCodeLabelColumn[];
  onEdit: (roughness: roughness) => void;
  onDelete: (roughness: roughness) => void;
}

export const ManageRoughnesssTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageRoughnesssTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.roughnesses && data.roughnesses.items &&
          data.roughnesses.items.length > 0 &&
          data.roughnesses.items.map((roughness) => (
            <tr key={`row-${roughness.id}`}>
              <td>
                {roughness.code}
              </td>
              <td>
                {roughness.label}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-roughness-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit roughness"
                  onClick={() => onEdit(roughness)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete roughness"
                  type="button"
                  onClick={() => onDelete(roughness)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.roughnesses ||
            !data.roughnesses.items ||
            data.roughnesses.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
